<template>
  <b-container fluid>
   
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <template v-else>
       <div class="card">
      <div class="card-body">
        <h4 class="mb-4">
          <strong>
            Lote de Pagamento : {{ this.filtrosLocal.idpayoutlot }} X Data :
            {{ moment(this.dtPayoutLot).format("DD/MM/YYYY") }}
          </strong>
        </h4>
      </div>
    </div>
      <!-- Main table element -->
      <div class="col-xl mb-2">
        <div class="dropdown d-inline-block col-2 pl-0">
          <a-dropdown placement="bottomRight" :trigger="['click']">
            <button
              type="button"
              class="btn col-12 btn-secondary dropdown-toggle drsopdown-toggle-noarrow"
              :disabled="!enableMenu"
            >
              Ações
            </button>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;">Suspeita de Fraude</a>
              </a-menu-item>
            <!--   <a-menu-item>
                <a href="javascript:;">Informações</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;">Outra Coisa</a>
              </a-menu-item> -->
              <a-menu-divider />
              <a-menu-item>
                <a href="javascript:;">Consultar Cliente</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
      <div class="col-xl">
        <a-table
          :columns="columns"
          :dataSource="groupedItems"
          :rowSelection="rowSelection"
          @change="onChangePage"
        >
          <span slot="dtTransaction" slot-scope="text">
            {{ moment(text).format("DD/MM/YYYY HH:mm:ss") }}</span
          >
          <span slot="nuAmountGross" slot-scope="text">
            {{ text | money }}</span
          >

          <span slot="cardIssuer" slot-scope="text">
            <img
              :src="GetImageCard(text)"
              :alt="text"
              width="auto"
              height="38px"
            />
          </span>
          <a-table
            slot="expandedRowRender"
            slot-scope="record"
            :columns="innerColumns"
            :data-source="record.result"
          >
            <span slot="moneyDisplay" slot-scope="text">
              {{ text | money }}</span
            >
            <span slot="dateDisplay" slot-scope="text"> {{ text | date }}</span>
            <span slot="installment" slot-scope="text"> {{ text }}x</span>
          </a-table>

          <template slot="transactionButton" slot-scope="text">
            <b-button size="sm" :href="`/transaction/${text}`"
              ><i class="fe fe-eye"></i
            ></b-button>
          </template>
        </a-table>
      </div>

      <!-- <b-table
        show-empty
        stacked="md"
        :items="displayItens"
        :fields="fields"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:cell(dtPayment)="text">
          {{ moment(text.value).format("DD/MM/YYYY") }}</template
        >
        <template v-slot:cell(dtTransaction)="text">
          {{ moment(text.value).format("DD/MM/YYYY") }}</template
        >

        <template v-slot:cell(installment)="text"> {{ text.value }}x</template>
        <template v-slot:cell(cardIssuer)="text">
          <img
            :src="GetImageCard(text.value)"
            :alt="text"
            width="auto"
            height="34px"
          />
        </template>

        <template v-slot:cell(grossAmount)="text">
          <span :style="GetAmountStyle(text.value)">
            {{ text.value | money }}
          </span></template
        >
        <template v-slot:cell(netAmount)="text">
          {{ text.value | money }}</template
        >
        <template slot="name" slot-scope="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            :href="`/transaction/${row.item.transactionHash}`"
            ><i class="fe fe-eye"></i
          ></b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table> -->
    </template>

    <!-- <b-modal ref="editar" hide-footer title="Editar Merchant" size="xl">
      <template v-slot:default="{ hide }">
        <formulario-equipamentos @hide="hide" :edicao="true" :dispositivo="dispositivoEditar" />
      </template>
    </b-modal> -->
  </b-container>
</template>

<script>
import { PayoutLotResource } from "@/resources/PayoutLot.resource.js";
import moment from "moment";
import { FormatCurrency, GetCardImagePath } from "@/utils/helpers.js";

let TAFFY = require("taffydb").taffy;
import TAFFYGROUP from "@/utils/taffy.extends.group.js";
TAFFYGROUP(TAFFY);

export default {
  name: "ListPayoutLotReceivables",

  data() {
    return {
      loading: false,
      dtPayoutLot: null,
      filtrosLocal: {
        idPayoutLot: 0
      },
      itens: [],
      displayItens: [],

      columns: [
        {
          title: "Id da Transação",
          dataIndex: "group",
          key: "group"
        },
        {
          title: "Total Parcelas",
          dataIndex: "count",
          key: "count"
        },
        {
          title: "Valor Bruto",
          dataIndex: "grossAmount",
          key: "grossAmount",
          scopedSlots: { customRender: "nuAmountGross" }
        },
        {
          title: "Valor Líquido",
          dataIndex: "netAmount",
          key: "netAmount",
          scopedSlots: { customRender: "nuAmountGross" }
        },

      /*    {
          title: "Lucro",
          dataIndex: "profitNet",
          key: "profitNet",
          scopedSlots: { customRender: "nuAmountGross" }
        }, */

        {
          title: "Bandeira",
          dataIndex: "cardIssuer",
          key: "cardIssuer",
          scopedSlots: { customRender: "cardIssuer" }
        },
        {
          title: "Transação",
          dataIndex: "groupLink",
          key: "groupLink",
          scopedSlots: { customRender: "transactionButton" }
        }
      ],

      innerColumns: [
        {
          title: "Data da Transação",
          dataIndex: "dtTransaction",
          key: "dtTransaction",
          scopedSlots: { customRender: "dateDisplay" }
        },
        {
          title: "Data Pagamento",
          dataIndex: "dtPayment",
          key: "dtPayment",
          scopedSlots: { customRender: "dateDisplay" }
        },
        {
          title: "Parcela",
          dataIndex: "installment",
          key: "installment",
          scopedSlots: { customRender: "installment" }
        },
        {
          title: "Valor Bruto",
          dataIndex: "grossAmount",
          key: "grossAmount",
          scopedSlots: { customRender: "moneyDisplay" }
        },
        {
          title: "Valor Líquido",
          dataIndex: "netAmount",
          key: "netAmount",
          scopedSlots: { customRender: "moneyDisplay" }
        }
      ],

      fields: [
        {
          key: "transactionHash",
          label: "Id da Transação",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "dtTransaction",
          label: "Data da Transação",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "dtPayment",
          label: "Data Pagamento",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "installment",
          label: "Parcela",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "grossAmount",
          label: "Valor Bruto",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "netAmount",
          label: "Valor Líquido",
          sortable: true,
          sortDirection: "desc"
        },

        /*    {
          key: "receivableStatus",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        }, */
        {
          key: "cardIssuer",
          label: "Bandeira",
          sortable: true,
          sortDirection: "desc"
        },

        { key: "actions", label: "Transação" }
      ],

      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      dateFormat: "DD/MM/YYYY",
      monthFormat: "YYYY/MM",
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YY"],
      localDB: null,
      groupedItems: [],
      enableMenu: false,
      selectedRows: []
    };
  },
  methods: {
    moment,

    FormatAmount(text) {
      return FormatCurrency(text);
    },

    GetImageCard(text) {
      return GetCardImagePath(text);
    },

    GetAmountStyle(status) {
      let styleAmount = "";
      if (status == "Estorno") {
        styleAmount = "text-decoration: line-through;";
      } else {
        styleAmount = "";
      }

      return styleAmount;
    },


   

    // lista de todos os dispositivos cadastrados
    getLista() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        // nessa situacao, precisamos buscar os dados, pois ainda nao forma consultados...
        this.loading = true;
        this.filtrosLocal.idpayoutlot = this.$route.params.id;

        const v = this;
        PayoutLotResource.getPayoutLottReceivable(this.filtrosLocal)
          .then(result => {
            try {
              v.itens[v.filtrosLocal.index] = result.data.payload;
              v.displayItens = v.itens[v.filtrosLocal.index].flat();
              v.localDB = TAFFY(v.displayItens);

              v.groupedItems = v.localDB().group("transactionHash");
              v.groupedItems = v.groupedItems.map((item, index) => {
                item["key"] = index;
                item["groupLink"] = item.group;
                item["cardIssuer"] = item.result[0].cardIssuer;
                item["netAmount"] = item.result.reduce((ac, cv) => {
                  return ac + cv.netAmount;
                }, 0);
                item["grossAmount"] = item.result.reduce((ac, cv) => {
                  return ac + cv.grossAmount;
                }, 0);

                item["profitNet"] = item.result.reduce((ac, cv) => {
                  return ac + cv.grossAmount - cv.netAmount;
                }, 0);

                return item;
              });

              v.dtPayoutLot = v.displayItens.reduce(function(init, current) {
                return current.dtPayment;
              });

              v.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason:
                      "Erro ao solicitar os dados, por favor tente novamente"
                  }
                }
              };
            }
          })
          .catch(e => {
            // Surpress
            v.loading = false;
          });
      } else {
        // se já temos, apenas movesmo para a lista de exibicao...
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },

    onChangePage(a) {
      // uma mudanca do page filter ocorreu, vamos atualizar a lista...
      this.filtrosLocal.index = a;
      this.getLista();
    },

    filtrar() {
      // se algum item do filtro for 0, mudar para null

      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getLista();
    }
  },
  computed: {
    rowSelection() {
      const v = this;
      return {
        /**
         * Funcoes para tratmento dos itens selecionados
         */
        onChange: (selectedRowKeys, selectedRows) => {
          v.enableMenu = false;
          v.selectedRows = [];
          if (selectedRows.length > 0) {
            v.enableMenu = true;
            v.selectedRows = selectedRows;
          }
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter(role => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    }
  },
  mounted() {
    this.filtrar();
  },
  created() {}
};
</script>
